import { format } from "date-fns";
import { type GetListParams } from "react-admin";

import { createApiClient } from "@/api";
import { type DataProviderSchema } from "@/utils";

import { type ReceiptsFilter } from "./types";

const apiClient = createApiClient("jsonld");
const BASE_URL = "/api/vpn/receipts";

const fetchListData = async ({ pagination, filter }: GetListParams) => {
  const typedFilter = filter as ReceiptsFilter;
  const dateRange = typedFilter.subscriptionCreatedAt;
  const after = dateRange?.after
    ? format(dateRange.after, "yyyy-MM-dd'T'00:00:00")
    : undefined;
  const before = dateRange?.before
    ? format(dateRange.before, "yyyy-MM-dd'T'23:59:59")
    : undefined;

  const response = await apiClient.GET(BASE_URL, {
    params: {
      query: {
        pagination: true,
        limit: pagination?.perPage,
        page: pagination?.page,
        "subscriptionCreatedAt[after]": after,
        "subscriptionCreatedAt[before]": before,
      },
    },
  });

  return {
    data: response.data?.["hydra:member"] ?? [],
    total: response.data?.["hydra:totalItems"] ?? 0,
  };
};

export const receiptsSchema: DataProviderSchema<"Receipt", "jsonld"> = {
  list: fetchListData,
  detail: async ({ id }) => {
    const { data } = await apiClient.GET(`${BASE_URL}/{id}`, {
      params: {
        path: { id: String(id) },
      },
    });

    if (!data) throw new Error("Detail not found");

    return { data };
  },
};
